export interface EventTileCoordinates {
  q: number;
  r: number;
}

export interface ActiveRandomEvent {
  id: string;
  startedAtTurn: number;
  tile?: EventTileCoordinates;
  turnsRemaining?: number;
  tileEnteredEmitted?: boolean;
}

export interface RandomEventEngineState {
  activeEvent: ActiveRandomEvent | null;
}

export function createEmptyRandomEventState(): RandomEventEngineState {
  return { activeEvent: null };
}

export function createInitialRandomEventEngineState(): RandomEventEngineState {
  return createEmptyRandomEventState();
}

export function resetRandomEventEngineState(): RandomEventEngineState {
  return createEmptyRandomEventState();
}
